import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { messages } from './messages';
import Global from '../../../store/global-selectors';

export const PickBatchStatusMessages = {
  Cancelled: messages.warehouseStatusCancelled,
  ReadyToPick: messages.warehouseStatusReadyToPick,
  Picking: messages.warehouseStatusPicking,
  Picked: messages.warehouseStatusPicked,
};

/**
 * Component for displaying the pick list printed status of a fulfillment plan.
 * @param {string} fulfillmentPlanId
 * @returns {JSX.Element}
 */
const WarehouseStatusColumn = ({ fulfillmentPlanId }) => {
  const pickBatchId = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'pickBatchId',
    }),
  );
  const pickBatch = useSelector((state) => Global.selectEntitiesPickBatchById(state, { pickBatchId }));
  const pickBatchStatus = pickBatch?.pickBatchStatusId;
  if (pickBatchStatus === undefined) {
    return React.Fragment;
  }
  const pickBatchStatusText = PickBatchStatusMessages[pickBatchStatus];
  return <div>{pickBatchStatusText ? <FormattedMessage {...pickBatchStatusText} /> : pickBatchStatus}</div>;
};

export const WarehouseStatus = {
  getMessageDescriptor: () => messages.warehouseStatus,
  id: 'warehouse-status',

  render: (data, { isExpanded = false, isFirstRow = true } = {}) => {
    if (isExpanded && !isFirstRow) {
      return null;
    }
    return <WarehouseStatusColumn fulfillmentPlanId={data.id} />;
  },
};
